/* Use-Case Roller — pill tabs control a horizontal scroll-snap roller of cards.
 * Multi-instance safe: each [data-uc-roller] scope is wired independently.
 * Pills pair with cards by DOM index. Click a pill -> smooth-scroll roller to that card.
 * Scrolling the roller updates the active pill. Editor-safe (re-inits on section load).
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.hasAttribute('data-uc-ready')) return;
    var track = root.querySelector('[data-uc-track]');
    if (!track) return;
    root.setAttribute('data-uc-ready', '');

    var pills = Array.prototype.slice.call(root.querySelectorAll('.ucr__pill'));
    var cards = Array.prototype.slice.call(track.querySelectorAll('.ucr__card'));

    function setActive(i) {
      pills.forEach(function (p, pi) { p.classList.toggle('is-on', pi === i); });
    }
    function scrollToCard(i) {
      var c = cards[i];
      if (!c) return;
      var padL = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      track.scrollTo({ left: Math.max(0, c.offsetLeft - padL), behavior: 'smooth' });
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var i = parseInt(p.getAttribute('data-i'), 10) || 0;
        setActive(i);
        scrollToCard(i);
      });
    });

    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bd = 1e9;
        cards.forEach(function (c, i) {
          var cc = c.offsetLeft + c.clientWidth / 2;
          var d = Math.abs(cc - center);
          if (d < bd) { bd = d; best = i; }
        });
        setActive(best);
      }, 80);
    }, { passive: true });

    // Expose programmatic navigation so external triggers (hero icons, etc.)
    // can drive this roller to a specific card. See the delegated handler below.
    var wrap = root.closest('[data-section-wrapper]');
    function navOffset() {
      var n = document.querySelector('.pin-nav--sticky.pin-nav--visible');
      return n ? n.getBoundingClientRect().height + 8 : 8;
    }
    root.__ucGoTo = function (i) {
      if (i < 0 || i >= cards.length) return;
      setActive(i);
      // The custom_id wrapper can be display:contents (no box), so its rect is
      // meaningless. Scroll to a real box: the wrapper only if it has height,
      // otherwise the roller element itself.
      var target = (wrap && wrap.getBoundingClientRect().height > 0) ? wrap : root;
      var y = target.getBoundingClientRect().top + window.pageYOffset - navOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      scrollToCard(i);
      // re-assert once layout settles (the vertical scroll can shift offsets)
      setTimeout(function () { scrollToCard(i); setActive(i); }, 520);
    };

    setActive(0);
  }

  // Resolve a "#base-N" href to a roller + 1-based card index.
  function resolveTrigger(href) {
    var m = (href || '').match(/^#(.+)-(\d+)$/);   // e.g. #usecases-3
    if (!m) return null;
    var wrap = document.getElementById(m[1]);
    if (!wrap) return null;
    var roller = wrap.matches('[data-uc-roller]')
      ? wrap
      : wrap.querySelector('[data-uc-roller]');
    if (!roller || typeof roller.__ucGoTo !== 'function') return null;
    return { roller: roller, idx: parseInt(m[2], 10) - 1 };
  }

  // One delegated listener for the whole page: any link like #usecases-3 rolls
  // the matching roller to card 3 and activates it. Robust to late/re-rendered DOM.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var t = resolveTrigger(a.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    t.roller.__ucGoTo(t.idx);
  });

  function boot() {
    document.querySelectorAll('[data-uc-roller]').forEach(init);
    // deep link on load (e.g. /products/mat#usecases-3 opens the 3rd card)
    var t = resolveTrigger(window.location.hash);
    if (t) setTimeout(function () { t.roller.__ucGoTo(t.idx); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify theme editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', boot);
})();
